import React from 'react'

export const HorizontalRule = () => {
  return <hr className="my-3 border-[0.5px] border-panelborder" />
}
